import React from 'react'
import { useSelector } from 'react-redux'
import { Segment, Container, Header, Button } from 'semantic-ui-react'
import { getExternalLinks } from 'stores/Links/Select'
import _ from 'lodash'

import localization from './localization'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import withLocalization from '@web/helpers/localizationUtils'

const MyHealthBottomBanner = ({ t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const links = _.merge({}, ...Object.values(useSelector(getExternalLinks)))

  return (
    <Segment style={styles.container}>
      <Container>
        <Header style={styles.header} as='h3'>
          {t('title')}
        </Header>
        <p style={styles.content}>{t('content')}</p>
        <Button
          style={styles.button}
          onClick={() =>
            window.open(_.get(links, 'UFD_Request_Medical_Records'), '_blank')
          }
        >
          {t('button')}
        </Button>
      </Container>
    </Segment>
  )
}

export default withLocalization(MyHealthBottomBanner, localization)
